// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"SunCard_infoCardContainer__RiPT-","title":"SunCard_title__uzU3H","sunInfo":"SunCard_sunInfo__fAbkS"};